// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=AgentMemoryApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=5054a9adb40701f6896e31be5defb090c80bc26e|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseUserMemoryBlockUpdateToJSON } from '../../../parsers/UserMemoryBlockUpdate';
import { parseUserMemoryFromJSON } from '../../../parsers/UserMemory';

export class AgentMemoryApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags AgentMemoryApi
   * @name AgentMemoryApiGetUserMemory
   * @summary Read the agent's memory about the connected user
   * @request GET:/customers/{customerId}/agent-memory
   * @secure
   */
  getUserMemory(
    {
      customerId,
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/agent-memory`,
        route: '/customers/{customerId}/agent-memory',
        method: 'GET',
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseUserMemoryFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags AgentMemoryApi
   * @name AgentMemoryApiUpdateUserMemoryBlock
   * @summary Replace or clear one block of the agent's memory about the user
   * @request PUT:/customers/{customerId}/agent-memory/{block}
   * @secure
   */
  updateUserMemoryBlock(
    {
      customerId,
      block,
    },
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/agent-memory/${block}`,
        route: '/customers/{customerId}/agent-memory/{block}',
        method: 'PUT',
        body: parseUserMemoryBlockUpdateToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseUserMemoryFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function AgentMemoryApi_Factory(t) { return new (t || AgentMemoryApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: AgentMemoryApi, factory: AgentMemoryApi.ɵfac, providedIn: 'root' });
}
